import { useEffect, useState } from "react";
import { Loader2, BellRing, Save, PlayCircle, Info, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export function ReminderSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  const [running, setRunning] = useState(false);

  useEffect(() => { api.get("/finance/settings").then((r) => setS(r.data.data)).catch((e) => toast.error(apiError(e))); }, []);

  const save = async (next = s) => {
    setSaving(true);
    try {
      const r = await api.put("/finance/settings", {
        reminders_enabled: next.reminders_enabled, test_email: next.test_email || null,
        wa_enabled: next.wa_enabled, test_phone: next.test_phone || null,
      });
      setS(r.data.data); toast.success("Pengaturan pengingat disimpan");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  const runNow = async () => {
    setRunning(true);
    try {
      const r = await api.post("/finance/reminders/run");
      const d = r.data.data;
      d.enabled ? toast.success(`Pengingat diproses: ${d.sent} terkirim, ${d.skipped} dilewati (${d.due_window} invoice dalam jendela H-3)`) : toast.warning("Pengingat otomatis sedang nonaktif");
    } catch (e) { toast.error(apiError(e)); } finally { setRunning(false); }
  };

  if (!s) return <div className="panel"><div className="rj-loading"><Loader2 className="spin" /> Memuat…</div></div>;
  const prod = s.recipient_mode === "customer";

  return (
    <div className="panel reminder-panel" data-testid="reminder-settings">
      <div className="panel-head"><div><h3><BellRing size={16} style={{ verticalAlign: -3 }} /> Pengingat Pembayaran (Email & WhatsApp)</h3>
        <p>Dikirim otomatis setiap hari pukul 08:00 WIB mulai H-{s.days_before} sebelum jatuh tempo, diulang tiap 24 jam sampai hari jatuh tempo.</p></div></div>
      <div className="reminder-row">
        <div><strong>Pengingat otomatis</strong><small>{s.reminders_enabled ? "Aktif" : "Nonaktif"}</small></div>
        <button className={`rj-switch ${s.reminders_enabled ? "on" : ""}`} onClick={() => save({ ...s, reminders_enabled: !s.reminders_enabled })}
          disabled={saving} data-testid="reminder-toggle" aria-label="Aktifkan pengingat"><i /></button>
      </div>
      <div className="reminder-row">
        <div><strong><MessageCircle size={14} style={{ verticalAlign: -2 }} /> Kirim juga via WhatsApp (Watzap)</strong>
          <small data-testid="reminder-wa-status">{s.watzap_configured ? (s.wa_enabled ? "Aktif · Watzap tersimpan (lihat hasil tes di panel Koneksi WhatsApp)" : "Nonaktif") : "Watzap belum diatur — isi API Key & Number Key di panel Koneksi WhatsApp"}</small></div>
        <button className={`rj-switch ${s.wa_enabled && s.watzap_configured ? "on" : ""}`} onClick={() => save({ ...s, wa_enabled: !s.wa_enabled })}
          disabled={saving || !s.watzap_configured} data-testid="reminder-wa-toggle" aria-label="Aktifkan WhatsApp"><i /></button>
      </div>
      <div className={`fin-info ${prod ? "ok" : ""}`} data-testid="reminder-mode">
        <Info size={15} />
        <span>{prod ? "Mode Production: pengingat dikirim ke email & nomor WhatsApp customer (dari data Odoo)."
          : "Mode Demo: agar customer asli tidak menerima pesan uji, pengingat hanya dikirim ke email & nomor WhatsApp uji di bawah. Setelah pindah ke Production, pengingat otomatis dikirim ke customer."}</span>
      </div>
      <div className="reminder-fields">
        <label className="rj-field">Email uji (mode Demo)
          <input className="rj-input" type="email" value={s.test_email || ""} onChange={(e) => setS({ ...s, test_email: e.target.value })}
            placeholder="finance@rasajuara.id" data-testid="reminder-test-email" />
        </label>
        <label className="rj-field">Nomor WhatsApp uji (mode Demo)
          <input className="rj-input" value={s.test_phone || ""} onChange={(e) => setS({ ...s, test_phone: e.target.value })}
            placeholder="0812xxxxxxx" data-testid="reminder-test-phone" />
        </label>
      </div>
      <div className="reminder-actions">
        <button className="rj-btn rj-btn-green" onClick={() => save()} disabled={saving} data-testid="reminder-save-btn">
          {saving ? <Loader2 size={16} className="spin" /> : <><Save size={16} /> Simpan</>}
        </button>
        <button className="rj-btn rj-btn-ghost" onClick={runNow} disabled={running} data-testid="reminder-run-btn">
          {running ? <Loader2 size={16} className="spin" /> : <><PlayCircle size={16} /> Jalankan pengingat sekarang</>}
        </button>
      </div>
      {s.last_run_at && <p className="fin-muted" style={{ marginTop: 10 }}>Terakhir dijalankan {fmtDateTime(s.last_run_at)}</p>}
    </div>
  );
}
